<template>
	<v-card-text class="details">
		<div class="details__row">
			<div class="details__cell details__cell--key">Is Configurable:</div>
			<div class="details__cell details__cell--value">
				<span>{{isConfigurable ? 'True' : 'False'}}</span>
			</div>
		</div>
		<div
			class="details__row"
			v-for="attributeInfo in attributesInfo"
			:key="attributeInfo.key"
			v-show="attributeInfo.value !== null && (!attributeInfo.is_field_setting || (isConfigurable && attributeInfo.is_field_setting))"
		>
			<div class="details__cell details__cell--key">{{attributeInfo.name}}:</div>
			<div class="details__cell details__cell--value">
				<span v-if="attributeInfo.dataType !== 'Bool'">{{attributeInfo.value}}</span>
				<span v-else>{{attributeInfo.value ? 'True' : 'False'}}</span>
			</div>
		</div>
	</v-card-text>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			isConfigurable: false,
			dataPoints: [
				{
					name: "ID",
					key: "id",
					configurable: false,
					is_field_setting: false,
					dataType: "Int"
				},
				{
					name: "Slug",
					key: "slug",
					configurable: false,
					is_field_setting: false,
					dataType: "String"
				},
				{
					name: "Is Hidden",
					key: "is_hidden",
					configurable: true,
					is_field_setting: false,
					dataType: "Bool"
				},
				{
					name: "Is Filterable",
					key: "in_decision_tree",
					configurable: true,
					is_field_setting: false,
					dataType: "Bool"
				},
				{
					name: "Label",
					key: "label",
					configurable: true,
					is_field_setting: true,
					dataType: "String"
				},
				{
					name: "Units",
					key: "units",
					configurable: true,
					is_field_setting: true,
					dataType: "String"
				},
				{
					name: "Field Type",
					key: "type",
					configurable: true,
					is_field_setting: true,
					dataType: "String"
				},
				{
					name: "Min",
					key: "min",
					configurable: true,
					is_field_setting: true,
					dataType: "Int"
				},
				{
					name: "Max",
					key: "max",
					configurable: true,
					is_field_setting: true,
					dataType: "Int"
				},
				{
					name: "Tooltip",
					key: "tooltip",
					configurable: true,
					is_field_setting: true,
					dataType: "Int"
				},
				{
					name: "Order",
					key: "order",
					configurable: false,
					is_field_setting: false,
					dataType: "Int"
				}
			]
		};
	},

	props: {
		id: {
			default: null
		},

		attribute: {
			default: false
		}
	},

	computed: {
		attributesInfo() {
			let data = [];

			_.forEach(this.dataPoints, d => {
				d.value = this.getObjectValue(
					d.key,
					this.attribute,
					d.dataType === "Bool" ? false : null,
					d.dataType === "Bool"
				);

				if (d.key === "type" && d.value !== null) {
					this.isConfigurable = true;
				}

				data.push(d);
			});

			return data;
		}
	}
};
</script>
